module.exports = __webpack_public_path__ + "img/01-logo.fa60d271.webp";